import { motion } from "framer-motion";
import { FileSearch, Wand2, TrendingUp } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: FileSearch,
    title: "We audit your database",
    body: "Send us your CRM export or a minimum 500 dead leads. We map every dormant contact, identify revenue gaps, and project recoverable income — at zero cost to you.",
  },
  {
    n: "02",
    icon: Wand2,
    title: "We run the reactivation",
    body: "Our consultative team handles outreach, scripts, follow-ups, and automation. You see every message before it goes out. Your brand stays in your voice.",
  },
  {
    n: "03",
    icon: TrendingUp,
    title: "You pay only for results",
    body: "Booked appointments. Closed deals. Recovered revenue. We share a transparent dashboard, and you pay a percentage of what we actually bring in.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div className="max-w-xl">
            <div className="text-xs uppercase tracking-[0.25em] text-[#ccff00] font-semibold mb-4">
              / How it works
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase">
              Three simple steps.
              <br />
              Real revenue.
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-base leading-relaxed">
            We do the work. You stay in control. The first audit costs nothing
            — because if we can’t find revenue, we don’t deserve a meeting.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 border border-white/10">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className={`relative p-8 lg:p-10 ${
                  i < 2 ? "lg:border-r border-white/10" : ""
                } ${i < 2 ? "border-b lg:border-b-0 border-white/10" : ""} hover:bg-[#0a0a0a] transition-colors`}
                data-testid={`step-${i + 1}`}
              >
                <div className="flex items-center justify-between mb-10">
                  <span className="font-mono-acc text-xs text-[#ccff00] tracking-widest">
                    {s.n}
                  </span>
                  <Icon className="w-5 h-5 text-white/40" />
                </div>
                <h3 className="font-display text-2xl lg:text-3xl uppercase mb-4">
                  {s.title}
                </h3>
                <p className="text-white/60 leading-relaxed text-sm">
                  {s.body}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
